import { useState, useId, cloneElement, ReactNode, useRef, useEffect } from "react";
import { useSpring, animated } from "react-spring";
import useMeasure from 'react-use-measure'
import "./collapsable-panel.scss";
import React from "react";
import { useTabControl } from "../../../hook/useTabControl";

type CollapsablePanelProps={
    headTitle: string;
    initCollapse: boolean;
    helpUrl?: string;
    css_classes?: string;
    children?:any;
}

const CollapsablePanel = (props:CollapsablePanelProps) => {
    const {headTitle,initCollapse,helpUrl,css_classes,children} = props
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [notification, setNotification] = useState<string | null>(null);

    const [measureRef, bounds] = useMeasure();

    const id = useId()

    const togglePanel = (e:any) => {
        setIsCollapsed((prevState:boolean) => !prevState);
        setNotification(headTitle+(isCollapsed ? ' Panel expanded' : ' Panel collapsed'));
    };
    const toggleHelp = () => {
        window.open(helpUrl, "_blank", 'width=600,height=400');
    };
    const panelContentAnimatedStyle = useSpring({
        height: isCollapsed ? 0 : bounds.height,
    });
    const toggleWrapperAnimatedStyle = useSpring({
        transform: isCollapsed ? "rotate(0deg)" : "rotate(180deg)",
    });

    const _css_classes = "pannel tooltipOMSContainer " + (css_classes ?? "");

    const handleKeyPress = (event: any) => {
        if (event.key === 'Enter') {
            togglePanel(event)
        }
    }

    useTabControl({ id, isCollapsed });

    useEffect(() => {setIsCollapsed(initCollapse)},[initCollapse])

    return (
            <div className={_css_classes}>
                <div
                    aria-live="assertive"
                    style={{
                        position: 'absolute',
                        width: '1px',
                        height: '1px',
                        margin: '-1px',
                        border: '0',
                        padding: '0',
                        clip: 'rect(0, 0, 0, 0)',
                        overflow: 'hidden'
                    }}
                >
                    {notification}
                </div>
                <div className="heading">
                    <div className="headIcon left">
                        <animated.div style={toggleWrapperAnimatedStyle}>
                            <span role="button"
                                onClick={togglePanel}
                                onKeyDown={handleKeyPress}
                                tabIndex={0}
                                className="focus-ring"
                                aria-expanded={isCollapsed ? "false" : "true"}
                                aria-label="collaps"
                                aria-controls={id}>
                                <svg aria-hidden={true} width="20px" height="25px" viewBox="0 0 1024 1024" style={{ cursor: 'pointer'}}>
                                    <path d="M64 351c0-8 3-16 9-22.2 12.3-12.7 32.6-13.1
                                        45.3-0.8l394.1 380.5L905.7 328c12.7-12.3 33-12 45.3 0.7s12 33-0.7 45.3L534.7
                                        776c-12.4 12-32.1 12-44.5 0L73.8 374c-6.5-6.3-9.8-14.6-9.8-23z" p-id="1705" fill="currentColor">
                                    </path>
                                </svg>
                            </span>
                        </animated.div>
                        <span className="headTitle focus-ring"
                            tabIndex={0}
                            role="button"
                            onClick={(e)=>togglePanel(e)}
                            onKeyDown={handleKeyPress}
                            aria-expanded={isCollapsed ? "false" : "true"}
                            aria-controls={id}>
                                {props.headTitle}
                        </span>

                    </div>
                    {props.helpUrl &&
                    <div className="headIcon right">
                        <div role="button" onClick={toggleHelp} tabIndex={0} className="focus-ring" aria-label="help">
                            <svg aria-hidden={true} width="16" height="25" fill="currentColor" viewBox="0 0 16 16" style={{ cursor: 'pointer'}}>
                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138
                                    0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343
                                    1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168
                                    1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0
                                    .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977
                                    1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267
                                    0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325
                                    6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584
                                    0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"/>
                            </svg>
                        </div>
                    </div>
                    }
                </div>
                <animated.div style={panelContentAnimatedStyle} className={`content`}>
                <div ref={measureRef} className="py-3" id={id}>
                    {children}
                </div>
                </animated.div>
            </div>
    );
};

export default CollapsablePanel;
